import React, { FC } from 'react';
import { Trans } from 'react-i18next';

export interface BuiltOnEnkrateiaProps {
  variant?: 'dark' | 'light';
}

const BuiltOnEnkrateia: FC<BuiltOnEnkrateiaProps> = ({ variant = 'light' }) => (
  <div className={`enkrateia-built-on-enkrateia ${variant}`}>
    <Trans i18nKey="pages.login.partOf">
      Built on the <b>Enkrateia Platform®</b>
    </Trans>
  </div>
);

export default BuiltOnEnkrateia;
